import { select } from 'd3';
import _L from '../../../../util/Labels';
import { Button } from '../../../controlD3/Button';
import { FormGenerator } from '../../../controlD3/Formulario';
import { ModalThingsUtil } from '../../../controlD3/ModalThings/Utils';
import { UIUtilFormat } from '../../../util/Format';
import { UIUtilGeneral } from '../../../util/Util';
import { AlumnoEdoCtaUtil } from '../AlumnoEdoCtaUtil';
import './ProcesoPago3FinalDetailView.scss';
import { AlEdoCtaPagoFormUtil } from './Util';

import CTipoProcesoPago = AlEdoCtaPagoFormUtil.CTipoProcesoPago;
type IItemCargoPago = AlEdoCtaPagoFormUtil.IItemCargoPago;


export class ProcesoPago3FinalDetailView {
    private container: HTMLDivElement;

    constructor(
        private modalThings: ModalThingsUtil.IModalThings,
        private infoGeneral: AlumnoEdoCtaUtil.ICurrentData,
        private procesoPagoData: AlEdoCtaPagoFormUtil.IDataForm,
        private formTipoPago: FormGenerator<AlEdoCtaPagoFormUtil.IDataForm>

    ) {
        this.container = document.createElement("div");
        this.container.className = "proceso_pago4_final_detail_view_container";
    }

    /**  */
    public _DrawView(): HTMLDivElement {
        const mt = this.modalThings;
        const infoGeneral = this.infoGeneral;
        const procesoPagoData = this.procesoPagoData;
        const formTipoPago = this.formTipoPago;
        const content = select<HTMLDivElement, any>(this.container);

        (() => {
            const paymentTypeName = AlEdoCtaPagoFormUtil._GetFormTipoPagoName(formTipoPago._Data.TipoPago);
            mt.Modal._SetTitle(_L("panelfinanzasedocuenta.tag_pay_resum", paymentTypeName));
        })();
        Button._EnableButton(mt.BtnRight, true);

        const fnBuildResumenContent = (body: d3.Selection<HTMLDivElement, any, any, any>, cargosToPay: IItemCargoPago[], description?: string) => {
            body.html(`
                            <label class="description ${(!description ? "hide" : "")}">${description}</label>
                            <div class="list ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                <div class="cargos_header">
                                    <div class="item_row">
                                        <label class="desc">${_L("panelfinanzasedocuenta.tag_cargo")}</label>
                                        <label class="debe">${_L("panelfinanzasedocuenta.tag_debe")}</label>
                                        <label class="pago">${_L("panelfinanzasedocuenta.tag_pago")}</label>
                                    </div>
                                </div>
                                <div class="cargos ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                    <div class="item_row">
                                        <div class="desc"></div>
                                        <div class="debe"></div>
                                        <div class="pago"></div>
                                    </div>
                                </div>
                                <div class="totales ${UIUtilGeneral.FBoxOrientation.Vertical}">
                                    <div class="item_row">
                                        <label class="desc"></label>
                                        <label class="debe"></label>
                                        <label class="pago"></label>
                                    </div>
                                </div>
                            </div>
                        `);

            body.select<HTMLDivElement>(".cargos").selectAll<HTMLDivElement, IItemCargoPago>(".item_row").data(cargosToPay).join(
                enter => {
                    let itemRow = enter.append("div")
                        .attr("class", "item_row");

                    itemRow.append("div").attr("class", "desc")
                        .html(d => `
                                        <label>${_L("panelfinanzasedocuenta.tag_period")}: ${d.Cargo.Periodo}</label>
                                        <label>${_L("panelfinanzasedocuenta.tag_descript")}: ${d.Cargo.Cargo}</label>
                                    `);
                    itemRow.append("div").attr("class", "debe").text(d => UIUtilFormat._CurrencyFmt(d.Cargo._ObtenerSaldoFinal()));
                    itemRow.append("div").attr("class", "pago").text(d => UIUtilFormat._CurrencyFmt(d.Pago));
                    return itemRow;
                },
                update => {
                    update.select(".desc").html(d => `
                                                    <label>${_L("panelfinanzasedocuenta.tag_period")}: ${d.Cargo.Periodo}</label>
                                                    <label>${_L("panelfinanzasedocuenta.tag_descript")}: ${d.Cargo.Cargo}</label>
                                                `)
                    update.select(".debe").text(d => UIUtilFormat._CurrencyFmt(d.Cargo._ObtenerSaldoFinal()));
                    update.select(".pago").text(d => UIUtilFormat._CurrencyFmt(d.Pago));
                    return update;
                },
                exit => exit.remove()
            );
        }


        let totalPago = 0;
        let deudaInicial = 0;

        procesoPagoData.CargosToPay
            .forEach(d => {
                deudaInicial += d.Cargo._ObtenerSaldoFinal();
                totalPago += d.Pago;
            });

        switch (procesoPagoData.TipoPago) {
            case CTipoProcesoPago.PagoSaldoTotal:
            case CTipoProcesoPago.PagoSaldoPeriodo:
                let strDescription = ""

                if (procesoPagoData.TipoPago == CTipoProcesoPago.PagoSaldoTotal) {
                    strDescription = _L("panelfinanzasedocuenta.tag_paysaldoacumperiodo");
                } else {
                    strDescription = _L("panelfinanzasedocuenta.tag_paysaldoperiodo");
                }

                fnBuildResumenContent(content, procesoPagoData.CargosToPay, (strDescription + ": " + infoGeneral.StrPeriodo));

                content.select<HTMLDivElement>(".totales")
                    .html(`
                                    <div class="item_row">
                                        <label class="desc">${_L("panelfinanzasedocuenta.infocta_totpagar")}:</label>
                                        <label class="debe"></label>
                                        <label class="pago sometotal">${UIUtilFormat._CurrencyFmt(totalPago)}</label>
                                    </div>
                                `);
                break;
            case CTipoProcesoPago.PagoParcial:
                fnBuildResumenContent(content, procesoPagoData.CargosToPay);

                content.select<HTMLDivElement>(".totales")
                    .html(`
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.infocta_totpagar")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago">${UIUtilFormat._CurrencyFmt(totalPago)}</label>
                                </div>
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.tag_deudainit")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago">${UIUtilFormat._CurrencyFmt(deudaInicial)}</label>
                                </div>
                                <div class="item_row">
                                    <label class="desc">${_L("panelfinanzasedocuenta.tag_deudaresta")}:</label>
                                    <label class="debe"></label>
                                    <label class="pago sometotal">${UIUtilFormat._CurrencyFmt(deudaInicial - totalPago)}</label>
                                </div>
                            `);
                break;
        }

        return this.container;
    }
}